var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",on:{"mouseover":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},[_vm._v(" "+_vm._s(_vm.displaying)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }